<div class="loading-box" *ngIf="!allAssetsLoaded">
  <app-loading-indicator></app-loading-indicator>
  <span>{{ loadedAssets.length }} / {{ assets?.length || 0 }} assets loaded</span>
</div>
<div
  class="print-overview {{ thumbnailSize }}"
  [style.--asset-size]="assetSize + '%'"
  [class.loading]="!allAssetsLoaded"
  (click)="close()"
>
  <h1 *ngIf="gallery.name || gallery.title">{{ gallery.name || gallery.title }}</h1>
  <h3 *ngIf="gallery.description" [innerHTML]="gallery.description"></h3>
  <div class="title-spacer" *ngIf="gallery.name || gallery.title || gallery.description"></div>
  <div class="print-row" *ngFor="let row of rows">
    <div class="assets">
      <div class="asset {{ asset.status }}" *ngFor="let asset of row" #el>
        <img
          [src]="asset | assetUrl : asset.version_data.watermark_uuid : 600 : false : false : false | async"
          [alt]="asset.version_data.asset_name"
          (load)="assetLoaded(asset)"
          (error)="assetLoaded(asset)"
        />
        <div class="name-container">
          <div *ngIf="showFavorites" class="favorites">
            <app-svg src="/assets/icons/heart-filled.svg" color="warn" *ngIf="asset.likes"></app-svg>
            <app-svg src="/assets/icons/heart-empty.svg" color="grey-50" *ngIf="!asset.likes"></app-svg>
            <span>{{ asset.likes }}</span>
          </div>
          <div class="asset-name {{ showFlags ? asset.status : '' }}">
            <ng-container *ngIf="showFlags">
              <app-svg src="/assets/icons/flag-check.svg" *ngIf="asset.status === 'approved'"></app-svg>
              <app-svg src="/assets/icons/flag-cross.svg" *ngIf="asset.status === 'rejected'"></app-svg>
            </ng-container>
            <span *ngIf="showFilename">{{ asset.version_data.asset_name }}</span>
            <span *ngIf="!showFilename && showFlags && asset.status === 'approved'">Approved</span>
            <span *ngIf="!showFilename && showFlags && asset.status === 'rejected'">Rejected</span>
          </div>
          <app-svg
            src="/assets/icons/tag-filled.svg"
            class="labels-icon"
            *ngIf="showColorlabels && asset.color_label"
            [attr.color]="asset.color_label"
          ></app-svg>
        </div>
      </div>
    </div>
  </div>
</div>
